// extracted by mini-css-extract-plugin
module.exports = {"html":"texts_html__YAHI5","inner":"texts_inner__2wRT9","htmlOverlay":"texts_htmlOverlay__3TyB4"};